import React from 'react';

const Footer = () => {
  return (
    <footer>
      {/* Main Footer Section - Now Light Gray */}
      <div
        className="bg-neutral/5 text-primary py-24"
        style={{
          backgroundColor: "#f2f2f2"
        }}>
        <div className="container-custom">
          <div className="flex flex-col items-center text-center">

            <div className="mb-12">
              <h3 className="text-xl font-bold tracking-widest uppercase mb-2">SOURCE CABINETRY</h3>
              <p className="text-primary/80 text-sm tracking-[0.2em] uppercase mb-6 font-medium">Architectural Cabinetry Studio</p>
              
              <p className="text-primary/70 text-sm font-medium mb-6">
                Kitchens • Bathrooms • Closets • Garages • Custom Built-Ins
              </p>
              
              <p className="text-primary/60 text-sm italic font-light">
                Built with precision. Designed without limits.
              </p>
            </div>
          </div>
        </div>
      </div>
      {/* Bottom Footer Section - Stays Navy */}
      <div className="bg-primary text-white py-8 border-t border-white/10">
        <div className="container-custom">
          <div className="flex flex-col items-center text-center">
            <div className="text-gray-400 text-xs tracking-widest">
              &copy; 2026 Source Cabinetry. All rights reserved.
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
